import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { withClientReview } from '../../utils/clientReview';
interface ReviewScreenCardProps {
  name: string;
  description: string;
  route: string;
  /** Static thumbnail; the real screen loads only after "Ver tela". */
  thumbnail: React.ReactNode;
}
export function ReviewScreenCard({
  name,
  description,
  route,
  thumbnail
}: ReviewScreenCardProps) {
  const navigate = useNavigate();
  return <article className="flex h-full flex-col overflow-hidden rounded-card border border-sand-line bg-white shadow-card" data-id="element-1023" data-mp="5p2apiboeg5s">
      <div className="border-b border-sand-line" data-id="element-1024" data-mp="3ny2xdk8knbnz">{thumbnail}</div>
      <div className="flex flex-1 flex-col px-2 pb-2 pt-2" data-id="element-1025" data-mp="3su0alhojg1wj">
        <h3 className="text-section text-deep" data-id="element-1026" data-mp="2ch368rxyn2vj">{name}</h3>
        <p className="mt-1 text-[12.5px] leading-relaxed text-muted" data-id="element-1027" data-mp="2cf8n9j691ku3">{description}</p>
        <div className="mt-auto pt-2" data-id="element-1028" data-mp="2hgo4t197x97q">
          <Button variant="outline" fullWidth onClick={() => navigate(withClientReview(route))} aria-label={`Ver tela: ${name}`} data-id="element-1029" data-mp="2hdjwbropzrb9">
            Ver tela
            <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-1030" data-mp="12ps37je63b0m" />
          </Button>
        </div>
      </div>
    </article>;
}